<template>
  <div class="row justify-content-center">
    <div class="col-md-9">
      <div
        class="cv_template_2"
        id="canvas_div_pdf"
        v-if="item"
        style="font-family: 'font_regular' !important"
      >
        <!--Right Part-->
        <div class="right_back">
          <!--Cv User Data-->
          <div class="cv_user_data">
            <!--Image-->
            <div class="user_image">
              <img :src="item.image" />
            </div>
            <!--Image-->
            <!--Back Shape-->
            <div class="back_shape" style="border: 0; box-shadow: none"></div>
            <!--Back Shape-->
            <!--Personal Info-->
            <div class="personal_info" style="border: 0; box-shadow: none">
              <!--Info List-->
              <ul class="info_list">
                <li style="list-style: none" v-if="item.email">
                  <i class="fal fa-envelope"></i>
                  <span>{{ item.email }}</span>
                </li>
                <li style="list-style: none" v-if="item.phone">
                  <i class="fal fa-phone"></i>
                  <span>{{ item.phone }}</span>
                </li>
                <li style="list-style: none" v-if="item.address">
                  <i class="fal fa-map-marker-alt"></i>
                  <span>{{ item.address }}</span>
                </li>
                <li style="list-style: none" v-if="item.gender">
                  <i class="fal fa-user"></i>
                  <span>{{
                    item.gender == "male" ? $t("single") : $t("married")
                  }}</span>
                </li>
                <li style="list-style: none" v-if="item.twitter_user">
                  <i class="fab fa-twitter"></i>
                  <span>{{ item.twitter_user }}</span>
                </li>
                <li style="list-style: none" v-if="item.linkedin_user">
                  <i class="fab fa-linkedin"></i>
                  <span>{{ item.linkedin_user }}</span>
                </li>
              </ul>
              <!--Info List-->
            </div>
            <!--Personal Info-->
            <!--Langs-->
            <div class="langs" style="border: 0; box-shadow: none">
              <h4>اللغات</h4>
              <div class="lang_item" v-if="item.arabic_level">
                <span>اللغة العربية</span>
                <ul class="lang_points">
                  <li
                    style="list-style: none"
                    class="fill"
                    v-for="lel in parseInt(item.arabic_level)"
                    :key="lel.id"
                  ></li>
                  <li
                    style="list-style: none"
                    class="no_fill"
                    v-for="lel in 4 - parseInt(item.arabic_level)"
                    :key="lel.id"
                  ></li>
                </ul>
              </div>
              <div class="lang_item" v-if="item.english_level">
                <span>اللغة الانجليزية</span>
                <ul class="lang_points">
                  <li
                    style="list-style: none"
                    class="fill"
                    v-for="lel in parseInt(item.english_level)"
                    :key="lel.id"
                  ></li>
                  <li
                    style="list-style: none"
                    class="no_fill"
                    v-for="lel in 4 - parseInt(item.english_level)"
                    :key="lel.id"
                  ></li>
                </ul>
              </div>
            </div>
            <!--Langs-->
            <!--Skills-->
            <div class="skills" v-if="item.interests">
              <h4>الهوايات</h4>
              <ul class="skills_list">
                <li v-for="skill in item.interests" :key="skill.id">
                  <span>{{ skill.name }}</span>
                </li>
              </ul>
            </div>
            <!--Skills-->
          </div>
          <!--Cv User Data-->
        </div>
        <!--Right Part-->
        <!--Left Part-->
        <div class="left_back">
          <!--User Job Title-->
          <div class="user_job_title">
            <h4 v-if="item.name">{{ item.name }}</h4>
            <h5 v-if="item.job_title">{{ item.job_title }}</h5>
          </div>
          <!--User Job Title-->
          <!--User Breif-->
          <div class="user_breif" v-if="item.desc">
            <h4><i class="far fa-clipboard-list"></i> المقدمة</h4>
            <p>
              {{ item.desc }}
            </p>
          </div>
          <!--User Breif-->
          <!--Work Experience-->
          <div class="work_experience" v-if="item.experiences">
            <h4><i class="fal fa-briefcase"></i> الخبرات العلمية</h4>
            <div
              class="work_card"
              v-for="exp in item.experiences"
              :key="exp.id"
            >
              <div class="date">
                <span>{{ exp.start_date.substring(-1, 4) }}</span>
                <span v-if="Boolean(!exp.is_still)">{{
                  exp.end_date.substring(-1, 4)
                }}</span>
                <span v-if="Boolean(exp.is_still)">حتى الان</span>
              </div>
              <div class="work">
                <span>{{ exp.job_title }}</span>
                <h4>{{ exp.name }}</h4>
                <p>
                  {{ exp.desc }}
                </p>
              </div>
            </div>
          </div>
          <!--Work Experience-->
          <!--Education-->
          <div class="work_experience" v-if="item.education">
            <h4><i class="fal fa-university"></i> الخبرات التعليمية</h4>
            <div class="work_card" v-for="edu in item.education" :key="edu.id">
              <div class="date">
                <span>{{ edu.start_date.substring(-1, 4) }}</span>
                <span v-if="Boolean(!edu.is_still)">{{
                  edu.end_date.substring(-1, 4)
                }}</span>
                <span v-if="Boolean(edu.is_still)">حتى الان</span>
              </div>
              <div class="work">
                <span>{{ edu.section_title }}</span>
                <h4>{{ edu.name }}</h4>
                <p>
                  {{ edu.desc }}
                </p>
              </div>
            </div>
          </div>
          <!--Education-->

          <!--Personal Skills-->
          <div class="work_experience">
            <h4>
              <i class="fal fa-star"></i>
              المهارات الشخصية
            </h4>
            <div class="progress_container" v-if="item.contact_level">
              <h5>مهارات التواصل</h5>
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="{ width: item.contact_level + '%' }"
                  aria-valuenow="25"
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  {{ item.contact_level }}%
                </div>
              </div>
            </div>
            <div class="progress_container" v-if="item.leader_level">
              <h5>ادارة الفريق</h5>
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="{ width: item.leader_level + '%' }"
                  aria-valuenow="25"
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  {{ item.leader_level }}%
                </div>
              </div>
            </div>
            <div class="progress_container" v-if="item.play_level">
              <h5>الترفيه</h5>
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="{ width: item.play_level + '%' }"
                  aria-valuenow="25"
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  {{ item.play_level }}%
                </div>
              </div>
            </div>
          </div>
          <!--Personal Skills-->

          <!--Time Mangement-->
          <div class="work_experience">
            <h4>
              <i class="fal fa-university"></i>
              ادارة الوقت
            </h4>
            <apexchart
              width="290"
              height="250"
              type="donut"
              :options="options"
              :series="newSer"
            ></apexchart>
          </div>
          <!--Time Mangement-->
        </div>
        <!--Left Part-->
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from "moment/moment";
export default {
  props: ["item"],
  data() {
    return {
      //Template Color
      templateColor: "",
      //Template Color

      options: {
        chart: {
          type: "radialBar",
        },

        legend: {
          show: true,
          horizontalAlign: "center",
          floating: false,
          fontSize: "16px",
          markers: {
            width: 20,
            height: 20,
            strokeWidth: 0,
            radius: 0,
          },
          itemMargin: {
            horizontal: 5,
            vertical: 0,
          },
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            donut: {
              size: "85%",
              labels: {
                show: true,
                name: {
                  show: true,
                },
                value: {
                  show: false,
                },
                total: {
                  show: true,
                  label: this.$t("cvsteps.wizard.timeMangement.title"),
                  color: "#29479A",
                  // formatter: function (w) {
                  //   return w.globals.seriesTotals.reduce((a, b) => {
                  //     return a + b;
                  //   }, 0);
                  // },
                },
              },
            },
          },
        },
        labels: ["العمل", "العائلة", "الترفيه"],
        colors: ["#7D5EE6", "#CAB6FB", "#9D9AEC"],
      },
      series: [44, 55, 41],

      //Colors
      colors: [
        {
          color: "#DFDFDF",
        },
        {
          color: "#0EB6D8",
        },
        {
          color: "#87CCAF",
        },
        {
          color: "#CEFFB1",
        },
        {
          color: "#E4A8F3",
        },
      ],
      //Colors
    };
  },
  methods: {
    //Change Color
    changeColor(color) {
      this.templateColor = color;
    },
    //Data Formate
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    //Data Formate
  },
  mounted() {
    this.changeColor(this.colors[0].color);
  },
  computed: {
    newSer() {
      return [
        Number(this.item.work_level),
        Number(this.item.family_level),
        Number(this.item.play_level),
      ];
    },
  },
};
</script>

<style scoped></style>
